export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ReinscripcionPage.vue?vue&type=template&id=f6e18a3a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/ReinscripcionPage.vue?vue&type=template&id=f6e18a3a&scoped=true&
// module id = 673
// module chunks = 4